/*
 * Copyright (c) 2023-2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Tooltip } from "reactstrap";
import { UniqKey } from "../util/Key";
import useUpdateState from "../util/useUpdateState";

const MoreInfoIcon = ({placement = "top", className="", style={}, children, icon="info-circle", iconColor=null}) => {
  // state
  const [state, , updateState] = useUpdateState({
    id: `more-info-icon-${UniqKey()}`,
    open: false
  });

  const _className = `${className} icon bi bi-${icon} ${iconColor ? `${iconColor}-icon` : ""}`
  return (
    <>
      <i id={state.id} style={iconColor ? {...style, color: iconColor} : {...style}} className={_className} />
      <Tooltip
        placement={placement}
        isOpen={state.open}
        target={state.id}
        toggle={() => updateState({ open: !state.open })}
      >
        {children}
      </Tooltip>
    </>
  )
};

export default MoreInfoIcon;
